import React, { useEffect, useRef } from "react";

interface ShadowWrapperProps {
  htmlContent: string;
}

const ShadowWrapper: React.FC<ShadowWrapperProps> = ({ htmlContent }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const shadowRootRef = useRef<ShadowRoot | null>(null); // shadowRoot 저장용 ref

  useEffect(() => {
    if (!containerRef.current) return;

    if (!shadowRootRef.current) {
      // 최초 1회만 attachShadow 실행
      shadowRootRef.current = containerRef.current.attachShadow({
        mode: "open",
      });
    }

    const shadowRoot = shadowRootRef.current;

    // shadowRoot 초기화 후 html+css 삽입
    shadowRoot.innerHTML = `
            
            <div class="inner-html">${htmlContent}</div>
        `;
  }, [htmlContent]);

  return <div ref={containerRef}></div>;
};

export default ShadowWrapper;
